import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UploadPdfRoutingModule } from './upload-pdf-routing.module';
import { UploadPdfComponent } from './upload-pdf.component';
import { CommonFileUploadModule } from 'src/app/global/common-file-upload/common-file-upload.module';
import { SharedModule } from '../shared.module';


@NgModule({
  declarations: [
    UploadPdfComponent
  ],
  imports: [
    CommonModule,
    UploadPdfRoutingModule,
    CommonFileUploadModule,
    SharedModule
  ],

  exports:[
    UploadPdfComponent
  ]
})
export class UploadPdfModule { }
